import { useFormik } from "formik";
import React, { useCallback } from "react";

import { Error, Input, Label } from "../../Components";
import { badlaSettingCreateSchema } from "../../Schema/BadlaSchema";
import { patchAxios, postAxios } from "../../Services/commonService";
import {
  API_BADLA_SETTING_CREATE,
  API_BADLA_SETTING_UPDATE,
} from "../../utils/api/ApiConstant";

const SettingCreate = ({ rowData, handleShowHide }) => {
  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: {
        settingName: rowData?.settingName || "",
        remark: rowData?.remark || "",
        defaultValue: rowData?.defaultValue || 15,
      },
      validationSchema: badlaSettingCreateSchema,
      onSubmit: (values) => {
        handleFormSubmit({ payload: values });
      },
    });

  const handleFormSubmit = useCallback(async ({ payload }) => {
    let res;
    if (rowData && rowData?._id) {
      res = await patchAxios({
        url: `${API_BADLA_SETTING_UPDATE}/${rowData._id}`,
        payload,
      });
    } else {
      res = await postAxios({ url: API_BADLA_SETTING_CREATE, payload });
    }

    if (res) handleShowHide();
  });

  return (
    <form onSubmit={handleSubmit}>
      <div className="row m-0 p-0">
        <div className="col-md-6 m-0 p-1">
          <Label htmlFor="settingName" className="form-label" isRequired={true}>
            Setting Name
          </Label>
          <Input
            type="text"
            className="form-control"
            name="settingName"
            id="settingName"
            placeholder="Enter exchange name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.settingName}
            autoFocus={true}
          />
          {errors.settingName && touched.settingName && (
            <Error>{errors.settingName}</Error>
          )}
        </div>

        <div className="col-md-6 m-0 p-1">
          <Label htmlFor="remark" className="form-label" isRequired={true}>
            Remark
          </Label>
          <Input
            type="text"
            className="form-control"
            name="remark"
            id="remark"
            placeholder="Enter exchange name"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.remark}
          />
          {errors.remark && touched.remark && <Error>{errors.remark}</Error>}
        </div>

        <div className="col-md-6 m-0 p-1">
          <Label
            htmlFor="defaultValue"
            className="form-label"
            isRequired={true}
          >
            Default Value
          </Label>
          <Input
            type="number"
            className="form-control"
            name="defaultValue"
            id="defaultValue"
            placeholder="Enter defaultValue"
            onChange={handleChange}
            onBlur={handleBlur}
            value={values.defaultValue}
          />
          {errors.defaultValue && touched.defaultValue && (
            <Error>{errors.defaultValue}</Error>
          )}
        </div>
      </div>
      <button type="submit" id="form-submit-btn" hidden={true}>
        Submit
      </button>
    </form>
  );
};

export default SettingCreate;
